const TOO_LARGE = 'O envio é grande demais para o servidor. Tente com uma planilha menor ou divida a avaliação.';

export async function readErrorMessage(error: any, fallback: string): Promise<string> {
	if (error?.response?.status === 413) {
		return TOO_LARGE;
	}
	const data = error?.response?.data;
	const text = data instanceof Blob ? await data.text() : data;
	if (typeof text !== 'string' || !text.trim() || text.trim().startsWith('<')) {
		return fallback;
	}
	return text.trim();
}
